<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Doc_ID">Document ID</label>
              <ep-input
                myFocus
                name="Doc_ID"
                [(ngModel)]="dsCollection.criteria.Doc_ID"
                format="integer-10"
                (change)="model.dirty = true"
              ></ep-input>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity">Entity</label>
              <ep-inline-search
                [noLabel]="true"
                class="w-100"
                name="Entity"
                [desc]="entityModel.entityName"
                [(ngModel)]="entityModel.entityID"
                [descFormControlPath]="'entityModel.entityName'"
                [formControlPath]="'entityModel.entityID'"
                [objectType]="'entity'"
                [placeholder]="'Select Entity'"
                [isStandalone]="true"
                [options]="{ autoSearch: false, allowClear: true }"
                (dataSelected)="setEntity($event)"
                (dataCleared)="clearEntity()"
              >
              </ep-inline-search>
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <aurora-button
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              variant="primary"
              (click)="auroraSubmitForm.onSubmit($event)"
            >
              Search
            </aurora-button>
            <aurora-button
              class="pull-right margin-l-5"
              type="button"
              (click)="dsCollection.criteria.Statement_ID = ''; model.dirty = true"
              style="margin-top: 16px"
              variant="secondary"
            >
              Reset
            </aurora-button>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #statementFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>
        <!--(itemChanged)="model.filter = $event"-->

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th style="min-width: 100px">Doc ID</th>
              <th style="min-width: 100px">Doc Type</th>
              <th style="min-width: 150px">Entity</th>
              <th style="min-width: 100px">Creation Date</th>
              <th style="min-width: 100px">Sent</th>
            </tr>
            <tr
              *ngFor="
                let statement of dsCollection.objectNodes
                  | epFilter : statementFilter.filter : statementFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(statement)"
            >
              <td>
                {{ statement.Doc_ID }}
              </td>
              <td>
                {{ statement.Doc_Type }}
              </td>
              <td>
                {{ statement.Entity_Name }}
              </td>
              <td>
                {{ statement.Doc_Creation_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ statement.Sent_Ind }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Statements</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
